import type { ReactNode } from "react";
import * as stylex from "@stylexjs/stylex";
import { steps } from "../onboarding-steps";
import type { OnboardingProgress } from "../onboarding-progress";
import { activeLineFor, failureLineFor } from "./onboarding-step-notices";
import { OnboardingStepAction } from "./onboarding-step-action";
import { styles } from "../onboarding.styles";

type OnboardingActiveStepProps = Readonly<{
  step: (typeof steps)[number];
  progress: OnboardingProgress;
  pollBroken: boolean;
  agentLabel: string;
  authFailed: boolean;
  signInHref: string;
  onSignIn(): void;
  playerForm: ReactNode;
  agentHandOff: ReactNode;
  continueCommand: string;
  onCopy(command: string): Promise<void>;
  leagueName: string;
}>;

export function OnboardingActiveStep({
  step,
  progress,
  pollBroken,
  agentLabel,
  authFailed,
  signInHref,
  onSignIn,
  playerForm,
  agentHandOff,
  continueCommand,
  onCopy,
  leagueName,
}: OnboardingActiveStepProps) {
  const activeLine = activeLineFor({
    key: step.key,
    progress,
    pollBroken,
    agentLabel,
  });
  const failureLine = failureLineFor({ key: step.key, progress });
  return (
    <>
      <p {...stylex.props(styles.title)}>{step.title}</p>
      <p
        aria-hidden="true"
        {...stylex.props(styles.counter)}
      >{`Step ${step.n} of ${steps.length}`}</p>
      <p {...stylex.props(styles.copy)}>{step.why}</p>
      {activeLine ? <p {...stylex.props(styles.copy)}>{activeLine}</p> : null}
      {failureLine ? (
        <p {...stylex.props(styles.copy, styles.foreground)}>{failureLine}</p>
      ) : null}
      <OnboardingStepAction
        step={step}
        progress={progress}
        authFailed={authFailed}
        signInHref={signInHref}
        onSignIn={onSignIn}
        playerForm={playerForm}
        agentHandOff={agentHandOff}
        continueCommand={continueCommand}
        onCopy={onCopy}
        leagueName={leagueName}
      />
    </>
  );
}
